import { Form } from 'antd';
import { useState } from 'react';

import { forgotPassword } from '@/apis';
import unionLogo from '@/assets/images/union-logo.png';
import * as AuthComponent from '@/components/Auth';
import BackButton from '@/components/BackButton';
import Logo from '@/components/Logo';
import OutlinedButton from '@/components/OutlinedButton';
import { useLoading } from '@/contexts/LoadingContext';
import { ButtonHtmlType, Path } from '@/enums';
import { useBreakpoint } from '@/hooks/useMediaQuery';

import * as Style from './ForgotPassword.style';

interface ForgotPasswordFormValues {
  email: string;
}

const ForgotPassword = () => {
  const [form] = Form.useForm<ForgotPasswordFormValues>();
  const [message, setMessage] = useState<string>('');
  const { withLoading } = useLoading();
  const { isMobileOrTablet } = useBreakpoint();

  const onFinish = async (values: ForgotPasswordFormValues) => {
    await withLoading(async () => {
      const response = await forgotPassword(values.email);
      setMessage(response.data.message);
    });
  };

  return (
    <Form
      form={form}
      onFinish={onFinish}
      layout="vertical"
      requiredMark={false}
      style={{ width: '100%' }}
    >
      <Style.FormContainer vertical>
        <Logo
          src={unionLogo}
          alt="Union Logo"
          height="80px"
          style={{ marginBottom: '24px' }}
        />

        <Style.Title>忘記密碼</Style.Title>

        <Form.Item
          name="email"
          rules={[
            {
              required: true,
              message: '請輸入電子信箱',
            },
            {
              type: 'email',
              message: '請輸入有效的電子信箱',
            },
          ]}
        >
          <AuthComponent.Input
            type="email"
            autoComplete="email"
            placeholder="請輸入電子信箱"
            width="100%"
            height="3.5rem"
          />
        </Form.Item>

        {!message && (
          <Style.ButtonGroup>
            <OutlinedButton
              htmlType={ButtonHtmlType.Submit}
              height="4rem"
              width="8rem"
            >
              提交
            </OutlinedButton>
          </Style.ButtonGroup>
        )}

        {message && <Style.SuccessMessage>{message}</Style.SuccessMessage>}

        {isMobileOrTablet && <BackButton to={Path.Login} />}
      </Style.FormContainer>
    </Form>
  );
};

export default ForgotPassword;
